import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";

import styles from "./../../style.module.scss";
import { useTranslation } from "react-i18next";
import { Button, Modal, Card, Row, Col, Space, Spin } from "antd";

// redux & query
import { setInspectModalVisible } from "../../goSlice";
import { useAppSelector, useAppDispatch } from "store/hook";

const Expired_Modal = React.memo(() => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const { ticket } = useParams();

  const [visible, setVisible] = useState(false);
  const [finish, setFinish] = useState(false);

  const { ticketData } = useAppSelector((state) => state.goPage);

  useEffect(() => {
    if (ticketData.ticket_inf.ticket === ticket) {
      if (ticketData.ticket_inf.active && ticketData.ticket_inf.expire_utc > Math.floor(Date.now()) / 1000) {
        // active and not expired (valid) -> invisible
        setVisible(false);
      } else {
        // inactive or expired -> visible
        setVisible(true);
      }

      if (ticketData.ticket_inf.progress.fix.done === ticketData.ticket_inf.progress.fix.total) {
        setFinish(true);
      } else {
        setFinish(false);
      }
    } else {
      setVisible(false);
    }
  }, [ticketData.ticket_inf]);

  return (
    <>
      <Modal title={""} visible={visible} centered className={styles.modalWrap} footer={false} closable={false}>
        <Space direction="vertical" size="middle" style={{ display: "flex" }}>
          <Row justify="center" align="middle" style={{ paddingTop: "10px" }}>
            {ticketData.ticket_inf.expire_utc <= Math.floor(Date.now()) / 1000 ? (
              <Col style={{ fontSize: "16px" }}>{`${t("ISMS.TicketExpired")}`}</Col>
            ) : (
              <Col style={{ fontSize: "16px" }}>{`${t("ISMS.TicketInactive")}`}</Col>
            )}
          </Row>
          <Row justify="center" align="middle" style={{ paddingBottom: "10px" }}>
            <Col style={{ fontSize: "16px" }}>
              {`${t("ISMS.Status")}`} : {finish ? `${t("ISMS.TicketFinished")}` : `${t("ISMS.TicketNotFinished")}`}
            </Col>
          </Row>
        </Space>
      </Modal>
    </>
  );
});

export default Expired_Modal;
